export const DURATION_MS = 6;
